/* eslint-disable */
// 设置用户信息
export const SET_USER_INFO = (state, data) => {
  // console.log(data)
  state.user = {
    ...state.user,
    ...data
  };
  // console.log(state.user)
};

// 清除用户信息
export const CLEAR_USER_INFO = state => {
  state.user = {};
  state.cars = [];
  // console.log(state.user)
  // console.log(state.cars)
};

// 设置加载状态
export const SET_LOAD_STATUS = (state, status) => {
  state.loading = status;
};

//设置购物车列表 （页面头部）
export const SET_USER_CARS = (state, data) => {
  state.cars = data;
  // console.log(data)
  // console.log(state.cars)
};

// 退出
export const LOGOUT = state => {
  state.user = {};
  state.cars = {};
  state.tracks = {
    current_page: 1,
    data: [],
    last_page: 1,
    per_page: 10,
    total: 0
  };

  (state.collects = {
    current_page: 1,
    data: [],
    last_page: 1,
    per_page: 10,
    total: 0
  }),
    (state.collectsStore = {
      current_page: 1,
      data: [],
      last_page: 1,
      per_page: 10,
      total: 0
    }),
    (state.messages = {
      business: {
        id: 1,
        title: "交易消息",
        type: 1,
        key: "business",
        link: "/member/setting/message/business",
        data: [],
        unread: false
      },
      system: {
        id: 2,
        title: "系统消息",
        type: 0,
        key: "system",
        link: "/member/setting/message/system",
        data: [],
        unread: false
      },
      interaction: {
        id: 3,
        title: "互动消息",
        type: 2,
        key: "interaction",
        link: "/member/setting/message/interaction",
        data: [],
        unread: false
      }
    });
};

// 设置地区信息
export const SETAREAS = (state, data) => {
  // console.log(data)
  state.areas = data;
};

// 设置地区信息
export const SETAREAS_LEVEL2 = (state, data) => {
  // console.log(data)
  state.areasLevel2 = data;
};

export const SET_CATEGORY = (state, data) => {
  // console.log(data)
  state.categories = data;
};

//设置用户消息
export const SET_USER_MESSAGE = (state, data) => {
  // console.log(data)
  state.messages = {
    ...state.messages,
    [data.key]: {
      ...state.messages[data.key],
      data: data.data,
      unread: data.unread
    }
  };
  // console.log(state.messages)
};

//清除用户消息
export const CLEAR_USER_MESSAGE = (state, data) => {
  // console.log(data)
  state.messages = {
    ...state.messages,
    [data.key]: {
      ...state.messages[data.key],
      data: data.data,
      unread: data.unread
    }
  };
  // console.log(state.messages)
};

//足迹列表
export const SET_TRACKS = (state, data) => {
  console.log("+++++++");
  console.log(data, "2222");
  state.tracks = {
    ...data.data
  };
  // console.log(state.tracks)
};

//收藏列表
export const SET_COLLECTS = (state, data) => {
  // console.log(data)
  state.collects = data.data;
  // console.log(state.collects)
};

export const SET_COLLECTS_STORE = (state, data) => {
  // console.log(data)
  state.collectsStore = data.data;
  // console.log(state.collectsStore)
};

export const SET_ARTICLE_CATEGORIES = (state, data) => {
  // console.log(data)
  state.articleCategories = data.data;
  // console.log(state.articleCategories)
};

export const SET_ATTRS = (state, data) => {
  // console.log(data)
  state.attrs = data.data.map(el => {
    return {
      ...el,
      [el.field_name]: ""
    };
  });
  // console.log(state.attrs)
};

export const SET_INDUSTRY = (state, data) => {
  //行业应用选项卡id
  state.industry = data;
};

//2025.net
export const SET_DIALOGSHOWIF = (state, data) => {
  state.dialogShowIf = data;
};

export const SET_DIALOGCONT = (state, data) => {
  state.dialogCont = data;
};
//切换导航栏显示隐藏
export const SET_ISNAV = (state, data) => {
  state.isNav = data;
};
export const SET_ISFATENAV = (state, data) => {
  state.isFateNav = data;
};
export const SET_ISVRNAV = (state, data) => {
  state.isVrNav = data;
};

export const SET_NAVALLINDEX = (state, data) => {
  state.navAllIndex = data;
};
